import React from 'react';
import { X, Check } from 'lucide-react';
import { formatCurrency } from '../../lib/utils';
import Button from '../ui/Button';

const RecurringReviewSheet = ({ pending, categories, onConfirm, onDeny, onConfirmAll, onClose }) => {
 return (
 <div className="fixed inset-0 bg-black/50 z-40 flex items-end" onClick={onClose}>
 <div className="bg-background w-full max-h-[70vh] overflow-hidden flex flex-col" onClick={e => e.stopPropagation()}>
 <div className="flex items-center justify-between p-4 border-b border-border flex-shrink-0">
 <div>
 <h3 className="text-[11px] font-semibold uppercase tracking-widest text-foreground">Recurring to review</h3>
 <p className="text-xs text-muted-foreground mt-0.5">
 {pending.length} transaction{pending.length !== 1 ? 's' : ''} from last month
 </p>
 </div>
 <div className="flex items-center gap-2">
 <Button size="sm" onClick={onConfirmAll} className="text-xs px-3 h-8">
 Approve all
 </Button>
 <button onClick={onClose} className="p-1 text-muted-foreground hover:text-foreground transition-colors">
 <X className="h-5 w-5" />
 </button>
 </div>
 </div>
 <div className="overflow-y-auto flex-1">
 {pending.map(txn => {
 const category = categories.find(c => c.id === txn.category_id);
 return (
 <div key={txn.id} className="flex items-center gap-3 px-4 py-3 border-b border-border last:border-b-0">
 <div className="flex-1 min-w-0">
 <p className="text-sm font-medium text-foreground truncate">
 {category?.name || 'Uncategorized'}
 </p>
 <p className="text-xs text-muted-foreground mt-0.5">
 {formatCurrency(Math.abs(txn.amount))} · day {txn.recurrence_day}
 {txn.payee ? ` · ${txn.payee}` : ''}
 </p>
 </div>
 <button
 onClick={() => onConfirm(txn)}
 className="h-9 w-9 flex items-center justify-center bg-success text-background hover:opacity-80 transition-opacity flex-shrink-0"
 aria-label="Confirm"
 title="Add this month"
 >
 <Check className="h-4 w-4" />
 </button>
 <button
 onClick={() => onDeny(txn)}
 className="h-9 w-9 flex items-center justify-center bg-destructive text-destructive-foreground hover:opacity-80 transition-opacity flex-shrink-0"
 aria-label="Stop recurring"
 title="Stop recurring"
 >
 <X className="h-4 w-4" />
 </button>
 </div>
 );
 })}
 </div>
 </div>
 </div>
 );
};

export default RecurringReviewSheet;
